<select
  class="form-control time-picker-select"
  [attr.name]="name || null"
  [disabled]="disabled"
  [ngModel]="timeValue"
  (ngModelChange)="onSelectChange($event)">
  <option [ngValue]="null">Select time</option>
  <option *ngFor="let option of timeOptions" [ngValue]="option" [disabled]="isOptionDisabled(option)">
    {{ option }}
  </option>
</select>
